"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginResolver = exports.calculateAndSetExpTime = exports.registerActivityHandler = exports.onActivity = void 0;

var consts = _interopRequireWildcard(require("./constants"));

var _support = require("./support");

/* global sessionStorage, setInterval */
var lastActivity;

var onActivity = function onActivity() {
  lastActivity = Date.now();
};

exports.onActivity = onActivity;

var registerActivityHandler = function registerActivityHandler() {
  onActivity();
  document.onkeypress = onActivity;
  document.onmousemove = onActivity;
  document.onscroll = onActivity;
};
/**
 * calculates and sets the appropriate settings for the expiration time for the access token
 *
 * @param {MidCore} mid the MidCore instance
 * @param {AccessInfo} accessInfo the decoded access token payload with iat and exp
 * @returns {void}
 */


exports.registerActivityHandler = registerActivityHandler;

var calculateAndSetExpTime = function calculateAndSetExpTime(mid, accessInfo) {
  if (!accessInfo) {
    throw new Error(mid.errors.ERR_UNHANDLED('accessInfo not valid'));
  }

  var now = Date.now();

  if (typeof accessInfo.iat !== 'number') {
    throw new Error(mid.errors.ERR_UNHANDLED("jwt token iat value invalid. expecting number, found ".concat(accessInfo.iat)));
  }

  if (typeof accessInfo.exp !== 'number') {
    throw new Error(mid.errors.ERR_UNHANDLED("jwt token exp value invalid. expecting number, found ".concat(accessInfo.exp)));
  } // exp and iat are in Seconds since UNIX Epoch, browser time is ms. Multiply by 1,000.


  var expInMs = 1000 * (accessInfo.exp - accessInfo.iat);
  sessionStorage.setItem(consts.MID_AUTH_EXPIRATION_TIME, "".concat(expInMs + now));
};
/**
 * Handle mid activity on a timer tick
 *
 * @param {MidCore} mid the MidCore instance
 * @param {Number} inactivityMS the number of milliseconds to wait for inactivity before logging out
 * @param {Number} expTimeBufferMs the number of milliseconds to count down to until preemptively refreshing the token
 * @return {function(): void} a setInterval callback function
 */


exports.calculateAndSetExpTime = calculateAndSetExpTime;

var onTick = function onTick(mid, inactivityMS, expTimeBufferMs) {
  return function () {
    var now = Date.now(); // check for activity timeout

    if (lastActivity + inactivityMS < now) {
      // inactive... time to logout
      mid.logout();
    } // check if the LoginInfo context is gone, we're done here


    if (!(0, _support.getLoginInfo)()) {
      console.error(mid.errors.ERR_UNHANDLED('LoginInfo removed, logging out.'));
      mid.logout();
    } // check the access token for liveliness


    var expTimeStr = sessionStorage.getItem(consts.MID_AUTH_EXPIRATION_TIME);

    if (!expTimeStr) {
      console.error(mid.errors.ERR_UNHANDLED('exptime missing! logging out.'));
      mid.logout();
    } else {
      var expTime = Number.parseInt(expTimeStr);

      if (isNaN(expTime)) {
        console.error(mid.errors.ERR_UNHANDLED('invalid exptime. expecting a Number, found:', expTimeStr, 'logging out.'));
        mid.logout();
      } else {
        if (expTime - expTimeBufferMs < now) {
          // we are in or past the buffer, attempt to refresh
          mid.refresh().then(function () {
            calculateAndSetExpTime(mid, (0, _support.getAccessInfo)());
          });
        }
      }
    }
  };
};
/**
 * creates a login resolver to set up the access token timer
 *
 * @param {MidCore} mid the mid instance
 * @param {number} inactivityMs the number of milliseconds to set for the inactivity timer
 * @param {number} expTimeBufferMs the number of milliseconds to set for the expiration refresh
 * @return {function(AccessInfo): void} a login resolver for use in the mid instance upon login
 */


var loginResolver = function loginResolver(mid, inactivityMs, expTimeBufferMs) {
  return function (_ref) {
    var accessInfo = _ref.accessInfo;

    if (!accessInfo) {
      throw new Error(mid.errors.ERR_UNHANDLED('Unable to set timer, accessToken is not a jwt'));
    }

    calculateAndSetExpTime(mid, accessInfo); // check every second

    if (!mid.timer) {
      mid.timer = setInterval(onTick(mid, inactivityMs, expTimeBufferMs), 1000);
    }
  };
};

exports.loginResolver = loginResolver;